"use client";

import { Pressable } from "@repo/design-system";
import { EyeIcon, EyeOffIcon } from "@repo/design-system/icons";
import { useTranslation } from "react-i18next";

import type { IPasswordVisibilityToggleProps } from "./types";

export const PasswordVisibilityToggle = ({
  isVisible,
  onToggle,
}: IPasswordVisibilityToggleProps) => {
  const { t } = useTranslation(["label"]);
  const Icon = isVisible ? EyeOffIcon : EyeIcon;

  return (
    <Pressable
      slot={null}
      onPress={onToggle}
      preventFocusOnPress
      aria-label={t(isVisible ? "hide_password" : "show_password", {
        ns: ["label"],
      })}
      aria-pressed={isVisible}
      className="flex items-center justify-center p-1 text-contentTertiary transition-colors hover:text-contentPrimary">
      <Icon color="currentColor" width={18} height={15} />
    </Pressable>
  );
};
